import React from 'react'

import { Navbar, Footer } from '../../../components';
import { Article1Doc } from '../individual';

export default function Article1() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <Article1Doc />
        <Footer />
    </div>
  )
}
